import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import { AdProviders, adunitMemo, ADUNIT_FALLBACK_MAP, ADUNIT_MAP } from '../../../constants';
import { useAdUnit } from '../../../useAdUnit';
import DealerAdIframe from '../../dealer';
const DesktopDevPageSide300x250Atf = /*#__PURE__*/ React.memo(({ safety ='off'  })=>{
    const _useAdUnit = useAdUnit(AdProviders.Gak, ADUNIT_MAP['UserDesktopDevPageSide300x250AtfGam'], safety, {
        refreshLimit: 30,
        refreshTimeout: 240000,
        size: [
            [
                300,
                100
            ],
            [
                320,
                250
            ],
            [
                320,
                50
            ],
            [
                250,
                250
            ],
            [
                300,
                250
            ],
            [
                180,
                150
            ],
            [
                300,
                50
            ],
            [
                234,
                60
            ],
            [
                120,
                240
            ],
            [
                320,
                100
            ],
            [
                125,
                125
            ],
            [
                200,
                200
            ],
            [
                300,
                200
            ]
        ],
        targeting: {
            unitType: 'atf'
        }
    }), { advertIsOff  } = _useAdUnit, slotAttr = _object_without_properties(_useAdUnit, [
        "advertIsOff"
    ]);
    if (advertIsOff === 'off') {
        return null;
    }
    if (advertIsOff === 'fallback') {
        return /*#__PURE__*/ React.createElement("div", {
            style: {
                width: '300px',
                height: '600px'
            }
        }, /*#__PURE__*/ React.createElement(DealerAdIframe, {
            realEstateId: ADUNIT_FALLBACK_MAP['UserDesktopDevPageSide300x250AtfGam'],
            neverCollapse: true,
            fillBlock: true
        }));
    }
    return /*#__PURE__*/ React.createElement("div", _extends({}, slotAttr));
}, adunitMemo);
DesktopDevPageSide300x250Atf.displayName = 'DesktopDevPageSide300x250Atf';
export default DesktopDevPageSide300x250Atf;
